
var hashObject = require('object-hash');

export function get_device_id({ state } ){


  // device id is really the user itself as this is unique
   var activeschool = state.user_schools.find(school => school.active === 1);
   
   // creat some sort of unique uuid...
   let uuidObject={
    username:activeschool.username,
    userAgent:navigator.userAgent,
   }
   
   let uuid=hashObject(uuidObject)

   return uuid

    
  }